<template>
  <Teleport to="body">
    <div class="pm" @mousedown.self="$emit('close')" @keydown.esc="$emit('close')">
      <div class="pm__box" role="dialog" aria-modal="true" :aria-label="title" tabindex="-1" ref="box">
        <div class="pm__head">
          <h4 class="pm__title">{{ title }}</h4>
          <button class="pm__x" aria-label="Cerrar" @click="$emit('close')"><span class="mdi mdi-close"></span></button>
        </div>
        <div class="pm__body"><slot /></div>
        <div v-if="$slots.footer" class="pm__foot"><slot name="footer" /></div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { onMounted, ref } from 'vue'
defineProps({ title: { type: String, required: true } })
defineEmits(['close'])
const box = ref(null)
onMounted(() => box.value?.focus())
</script>

<style scoped>
.pm { position: fixed; inset: 0; z-index: 1500; display: flex; align-items: center; justify-content: center; padding: 16px; background: rgba(15, 23, 42, 0.45); }
.pm__box { width: 100%; max-width: 440px; background: #fff; border-radius: 12px; box-shadow: 0 20px 50px rgba(15, 23, 42, 0.25); outline: none; max-height: calc(100vh - 32px); display: flex; flex-direction: column; }
.pm__head { display: flex; align-items: center; justify-content: space-between; padding: 18px 20px 0; }
.pm__title { margin: 0; font: 700 16px var(--font-display); color: #1e3a5f; }
.pm__x { background: none; border: none; cursor: pointer; font-size: 18px; color: #94a3b8; padding: 4px; }
.pm__x:hover { color: #475569; }
.pm__body { padding: 14px 20px 18px; overflow-y: auto; font: 400 13px/1.55 var(--font-body); color: #475569; }
.pm__foot { display: flex; justify-content: flex-end; gap: 8px; padding: 0 20px 18px; }
</style>